import React, { useState } from 'react';
import { Quote } from 'lucide-react';
import { ReviewsTab } from './reviews/ReviewsTab';
import { RecensioniTab } from './reviews/RecensioniTab';
import { RassegnaStampaTab } from './reviews/RassegnaStampaTab';
import { FeedbackTab } from './reviews/FeedbackTab';

export const Reviews = () => {
  const [activeTab, setActiveTab] = useState('recensioni');

  return (
    <section id="recensioni" className="section-container bg-bg-page py-24">
      <div className="container mx-auto px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-6">
              <Quote className="w-8 h-8 text-brand-primary" />
              <h2 className="heading-1 text-brand-primary">Recensioni e Feedback dei Lettori</h2>
            </div>
            <div className="w-24 h-1 bg-brand-primary mx-auto mb-8"></div>
            <p className="body-medium text-text-secondary">
              Cosa dicono i lettori di "Cronache dal fronte invisibile"
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <ReviewsTab
              active={activeTab === 'recensioni'}
              label="Recensioni"
              onClick={() => setActiveTab('recensioni')}
            />
            <ReviewsTab
              active={activeTab === 'stampa'}
              label="Rassegna Stampa"
              onClick={() => setActiveTab('stampa')}
            />
            <ReviewsTab
              active={activeTab === 'feedback'}
              label="Feedback"
              onClick={() => setActiveTab('feedback')}
            />
          </div>

          {activeTab === 'recensioni' && <RecensioniTab />}
          {activeTab === 'stampa' && <RassegnaStampaTab />}
          {activeTab === 'feedback' && <FeedbackTab />}
        </div>
      </div>
    </section>
  );
};
